import {FC, useState} from "react";
import {Button, ButtonProps, Table} from "semantic-ui-react";
import {
    IDataTableData,
    IColumnMetadata,
    ICustomColumnsTransformation
} from "../../features/application/api/applicationModels";
import formatter from "../../util/dataFormatUtil";
import DataTableMetricValueDisplayElement from "./DataTableMetricValueDisplayElement";

interface IProps {
    staticColumns: IColumnMetadata[];
    customColumns: ICustomColumnsTransformation;
    configurableColumns?: IColumnMetadata[];
    data: IDataTableData;
    rowIndex: number;
    isMobileScreen: boolean;
    renderDetailBody?:
        | ((data: IDataTableData, isMobileScreen: boolean) => JSX.Element)
        | undefined
        | null;
}

const DataTableRow: FC<IProps> = (props: IProps) => {
    const [detailIsOpen, setDetailIsOpen] = useState(false);

    const detailRow =
        props.renderDetailBody && detailIsOpen
            ? props.renderDetailBody(props.data, props.isMobileScreen)
            : null;

    function getExpandButton(
        rowIsExpanded: boolean,
        onClick: (
            event: React.MouseEvent<HTMLButtonElement>,
            data: ButtonProps
        ) => void
    ) {
        if (rowIsExpanded) {
            return (
                <Button
                    secondary
                    size="mini"
                    icon="angle up"
                    onClick={(event, data) => onClick(event, data)}
                    basic
                />
            );
        } else {
            return (
                <Button
                    secondary
                    size="mini"
                    icon="angle down"
                    onClick={(event, data) => onClick(event, data)}
                    basic
                />
            );
        }
    }

    const expandColumn = props.renderDetailBody ? (
        <Table.Cell collapsing>
            {getExpandButton(detailIsOpen, (_event, _buttonProps) => {
                const newDetailIsOpen = !detailIsOpen;
                setDetailIsOpen(newDetailIsOpen);
            })}
        </Table.Cell>
    ) : null;

    return (
        <>
            <Table.Row>
                {expandColumn}
                {props.staticColumns.map((column, columnIndex) =>
                    props.customColumns[column.key] !== undefined ? (
                        props.customColumns[column.key].getCustomColumnMetaData(
                            props.data,
                            column,
                            props.isMobileScreen
                        ).element
                    ) : (
                        <Table.Cell
                            key={"Cell" + columnIndex + column.key}
                            style={{fontWeight: "normal"}}
                        >
                            <DataTableMetricValueDisplayElement
                                isMobileScreen={props.isMobileScreen}
                                metricName={column.label}
                                metricDisplayValue1={formatter.dataTableDisplayValue(
                                    props.data[column.key],
                                    column
                                )}
                            />
                        </Table.Cell>
                    )
                )}
                {props.configurableColumns?.map((column, columnIndex) =>
                    props.customColumns[column.key] !== undefined ? (
                        props.customColumns[column.key].getCustomColumnMetaData(
                            props.data,
                            column,
                            props.isMobileScreen
                        ).element
                    ) : (
                        <Table.Cell key={"Cell" + columnIndex + column.key}>
                            <DataTableMetricValueDisplayElement
                                isMobileScreen={props.isMobileScreen}
                                metricName={column.key}
                                metricDisplayValue1={formatter.dataTableDisplayValue(
                                    props.data[column.key],
                                    column
                                )}
                            />
                        </Table.Cell>
                    )
                )}
            </Table.Row>
            {detailRow}
        </>
    );
};

export default DataTableRow;
